export default "__VITE_ASSET__84bfad8c__"